import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaLock } from "react-icons/fa";
import "../../../styles/pages-styles/main-dashboard-pages-styles/knowledge-pages-styles/KnowledgeTutor.css";
// import QuestionDropDown from "../../../components/question-components/QuestionDropDown";
import axios from "axios";

const KnowledgeTutor = () => {
  const navigate = useNavigate();
  const [subscriptionRequired, setSubscriptionRequired] = useState(false);
  const [loading, setLoading] = useState(false); // Add loading state

  const handleStartKnowledgeTutor = async () => {
    setLoading(true); // Set loading to true when starting
    setSubscriptionRequired(false); // Reset subscriptionRequired state
    const userId = sessionStorage.getItem("userId");

    try {
      const response = await axios.get(`/user/getUserProfile/${userId}`);

      if (response.status === 200) {
        if (response.data.user.currentPlan === "Free") {
          setSubscriptionRequired(true);
          // navigate("/dashboard/subscribe") // removed navigate here
        } else {
          navigate("/knowledgeexam");
        }
      }
    } catch (err) {
      if (err.response && err.response.status === 402) {
        navigate("/dashboard/subscribe"); // Keep this in case your backend also sends 402 for this route in the future.  Important to keep this
      } else {
        // Handle other errors if needed
        console.error("Error fetching user profile:", err);
        // Optionally set an error state to display a message to the user
      }
    } finally {
      setLoading(false); // Set loading to false when done
    }
  };

  if (subscriptionRequired) {
    return (
      <div className="subscription-required-container">
        <FaLock className="lock-icon" />
        <h2 className="subscription-heading">Unlock Knowledge Tutor</h2>
        <p className="subscription-message">
          Access to the Knowledge Tutor requires a premium subscription.
        </p>
        <p className="subscription-benefit">
          Upgrade now to enhance your learning with our spaced repetition
          system.
        </p>
        <button
          className="upgrade-button"
          onClick={() => navigate("/dashboard/subscribe")}
        >
          Upgrade to Premium
        </button>
        {/* You can add more details or benefits here */}
      </div>
    );
  }

  return (
    <div className="knowledge-tutor-container">
      <div className="knowledge-tutor-header">
        <div className="knowledge-tutor-header-content">
          <div className="knowledge-tutor-header-text">
            <p>
              The knowledge tutor is a collection of thousands of high-yield
              exam facts powered by an ANKI-style spaced repetition system. Our
              algorithms turn these facts into mini-questions that are
              constantly evolving, ensuring the most important facts are given
              the highest priority.
            </p>
            <button>More</button>
          </div>

          <div className="knowledge-tutor-progress">
            <p>
              You've been tested on 9% (103/1134) of A++ to A facts. Acceptable
              recall has been achieved in 72% of these facts{" "}
              <a href="#">more</a>
            </p>
          </div>
        </div>

        <div className="knowledge-tutor-start-section">
          <button
            className="knowledge-tutor-start-button"
            onClick={handleStartKnowledgeTutor}
            disabled={loading}
          >
            {loading ? (
              <div className="spinner"></div>
            ) : (
              "Start the Knowledge tutor"
            )}
          </button>
        </div>
      </div>

      {/* <div className="knowledge-tutor-main-content">
        <div className="knowledge-tutor-categories">
          <div className="knowledge-tutor-card">
            <h5>HIGH-YIELD RATING</h5>
            <QuestionDropDown />
          </div>

          <div className="knowledge-tutor-card">
            <h5>DIFFICULTY RATING</h5>
            <div className="difficulty-slider">
              <input type="range" min="0" max="100" className="form-range" />
              <div className="difficulty-slider-label">
                <span>Easy</span>
                <span>Hard</span>
              </div>
            </div>
          </div>

          <div className="knowledge-tutor-card">
            <h5>FACT SELECTION</h5>
            <QuestionDropDown placeholder="Spaced repetition (individual facts)" />
          </div>
        </div>

        <div className="knowledge-tutor-sidebar">
          <h5 className="recent-sessions-title">RECENT SESSIONS</h5>

          <div className="recent-session-item">
            <div className="recent-session-details">
              <p>All categories (ALL - 0-100)</p>
              <p>4 days ago</p>
            </div>
            <button className="recent-session-continue">Continue</button>
          </div>

          <div className="recent-session-item">
            <div className="recent-session-details">
              <p>Psychiatry (ALL - 0-100)</p>
              <p>5 days ago</p>
            </div>
            <button className="recent-session-continue">Continue</button>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default KnowledgeTutor;
